//shared containers
import { Footer } from '@/containers-m/Footer';
import { Navigation } from '/containers-m/';
import { Logos, logos_list } from '@/containers-latam/Logos';
import { Proof } from '@/containers-latam/Proof';
import { FAQ } from '@/containers-latam/FAQ';

//containers
import {
  Hero,
  Lineup,
  LiveInProduction,
  ScenarioTheater,
  AgenticWorkflow,
  Rails,
  EndCTA,
} from './containers/index';

//styles
import { PageWrapper, AIGlobalStyle } from './AI.styles';

// The LATAM home. Same section order as the US home (/): the lineup of the
// eleven agents, what we automate, the Freight Experts, one workflow, the
// integrations, the scenarios and the outcomes; the last section points to
// Opendock instead of the TMS.
function AI({
  hero_content,
  logosTitle,
  lineup_content,
  liveInProduction_content,
  freightExperts_content,
  platformScale_content,
  scenarioTheater_content,
  endCta_content,
  opendockCta_content,
  agenticWorkflow_content,
  rails_content,
  proof_content,
  faq_content,
  agentHrefs,
  numberLocale,
  nav,
  footer,
}) {
  return (
    <PageWrapper>
      <AIGlobalStyle />
      <Navigation theme="dark" nav={nav} />
      <Hero content={hero_content} />
      <Logos logos={logos_list} label={logosTitle} />
      <Lineup content={lineup_content} />
      <LiveInProduction
        content={liveInProduction_content}
        freightExpertsContent={freightExperts_content}
        platformScaleContent={platformScale_content}
        agentHrefs={agentHrefs}
        ctaHref={endCta_content.ctaHref}
        numberLocale={numberLocale}
      />
      <AgenticWorkflow content={agenticWorkflow_content} />
      <EndCTA variant="top" content={endCta_content} />
      <Rails content={rails_content} />
      <ScenarioTheater content={scenarioTheater_content} />
      <Proof
        outcomes={proof_content.outcomes}
        kicker={proof_content.kicker}
        title={proof_content.title}
        locale={numberLocale}
      />
      <EndCTA variant="top" id="opendock" content={opendockCta_content} />
      <FAQ content={faq_content} />
      <EndCTA variant="bottom" content={endCta_content} />
      <Footer config={footer} />
    </PageWrapper>
  );
}

export default AI;
export { AI };
